<template>
  <div class="location">
    <div class="location-address margins-off">
      <div v-if="address.district">{{ address.district }}</div>
      <div v-if="address.city">{{ address.city }}</div>
      <div v-if="county">{{ county }}</div>
      <div v-if="state">{{ state }}</div>
      <div v-if="country">{{ country }}</div>
    </div>
    <slot>
      <div class="location-footer">
        <div class="location-controls"></div>
      </div>
    </slot>
  </div>
</template>

<script>
export default {
  props: {
    address: Object
  },

  computed: {
    county: function() {
      const county = this.address.additionalData.filter(
        data => data.key == "CountyName"
      )[0];

      if (!county) return null;

      // Is "County" already in the name?
      const regex = /County/g;
      const found = county.value.match(regex);

      if (found) return county.value;
      return county.value + " County";
    },

    state: function() {
      const state = this.address.additionalData.filter(
        data => data.key == "StateName"
      )[0];

      if (!state) return null;
      return state.value;
    },

    country: function() {
      const country = this.address.additionalData.filter(
        data => data.key == "CountryName"
      )[0];

      if (!country) return null;
      return country.value;
    }
  }
};
</script>

<style lang="scss">
.location {
  transition: all 0.3s ease-out;
  transform-style: preserve-3d;
  transform-origin: top left;

  // This error class is being applied by a parent element in the App component. For that reason this style does not really belong here.
  .error & {
    filter: blur(10px);
    opacity: 0.25;
  }
}

.location-address > div {
  font-weight: 800;
  hyphens: auto;
  overflow-wrap: break-word;
  word-wrap: break-word;
  width: 100%;

  &:first-child {
    font-size: 15vmin;
    font-weight: 900;
    line-height: 1;
  }

  &:nth-child(2) {
    font-size: 11.25vmin;
    font-weight: 900;
    line-height: 1.1;
    opacity: 0.8;
  }

  &:nth-child(3) {
    font-size: 8.75vmin;
    line-height: 1.2;
    opacity: 0.65;
  }

  &:nth-child(4) {
    font-size: 6.25vmin;
    line-height: 1.4;
    opacity: 0.5;
  }

  &:nth-child(5) {
    font-size: 5vmin;
    line-height: 1.4;
    opacity: 0.35;
  }
}

// Small modifier
.location.small .location-address > div {
  &:first-child {
    font-size: 1.75em;
  }

  &:nth-child(2) {
    font-size: 1.5em;
  }

  &:nth-child(3) {
    font-size: 1.25em;
  }

  &:nth-child(4) {
    font-size: 1em;
  }

  &:nth-child(5) {
    font-size: 0.75em;
  }
}

.location-footer {
  align-items: baseline;
  display: flex;
  justify-content: space-between;
  margin-top: 0;
}

.location-controls.large {
  font-size: 1.25em;
  margin-top: 1.5rem;
}

.location-time {
  font-size: 0.75em;
}
</style>
